import { useCallback, useState } from 'react'
import { initiateYouTubeConnection } from '@/lib/api'
import ConnectPlatform from '@/components/ConnectPlatform'

const YouTubeConnect = () => {
  const [connecting, setConnecting] = useState(false)
  const stopConnecting = useCallback(() => setConnecting(false), [])

  const handleConnect = async () => {
    setConnecting(true)
    try {
      await initiateYouTubeConnection()
    } catch (error) {
      console.error('Failed to initiate YouTube connection:', error)
      setConnecting(false)
    }
  }

  return (
    <ConnectPlatform
      slug="youtube"
      name="YouTube"
      iconBg="#FF0000"
      shows="Brands see your real subscribers and watch time, so you get better offers."
      buttonLabel="Connect YouTube"
      onConnect={handleConnect}
      connecting={connecting}
      onReturn={stopConnecting}
    />
  )
}

export default YouTubeConnect
